import { atom } from 'recoil'
import { CurrentImage } from '../selectors/CurrentImage'
import { IImage } from '../../types/IImage'

export const PreviousImage = atom<IImage | undefined>({
  key: 'previous-image-atom',
  default: CurrentImage,
})
